module.exports = {
  "course": {
    "courseManager": "课程管理",
    "courseInfo": "课程信息",
    "courseName": "课程名称",
    "courseNameHint": "请输入课程名称",
    "feeType": "付费金额（元）",
    "feeTypeHint": "请选择付费方式",
    "free": '免费',
    "times": '按次收费',
    "once": '一次性收费',
    "amount": '付费金额',
    "amountHint": '请输入付费金额',
    "amountHint2": '请输入正确的付费金额',
    "addCourse": "新增课程",
    "editCourse": "编辑课程",
    "courseClassify": "课程分类",
    "classifyName": "分类名称",
    "courseClassifyHint": "请选择课程分类",
    "addCourseClassify": "新增分类",
    "editCourseClassify": "编辑分类",
    "fatherClassify": "上级分类",
    "fatherClassifyHint": "请选择上级分类",
    "classifyDetails": "分类描述",
    "classifyDetailsHint": "请输入分类描述",
    "viewSort": "显示序号",
    "viewSortHint": "请输入显示序号",
    "status": "分类状态",
    "statusAll": "全部",
    "statusNormal": "正常",
    "statusStop": "失效",
    "courseStatus": "课程状态",
    "courseProfile": "课程介绍",
    "courseProfileHint": "请输入课程介绍",
    "courseDetail": "课程详情",
    "courseDetailHint": "请输入课程详情",
    "searchHint": '请输入课程名称、课程标签搜索',
    "remark": "备注",
    "remarkHint": "请输入备注",
    "courseDirectory": "课程目录",
    "courseDirectoryHint": "请先添加一个课程目录",
    "courseDirectoryHint2": "请先上传一个课程课件、教案、视频或者音频",
    "chapter": "章节",
    "chapterName": "章节名称",
    "chapterNameHint": "请输入章节名称",
    "chapterProfile": "章节介绍",
    "chapterProfileHint": "请输入章节介绍",
    "cover": "封面",
    "coverHint": "请上传一张课程封面",
    "courseware": "课程课件",
    "coursewareHint": "支持pdf/ppt/pptx文件",
    "teachPlan": "教案",
    "teachPlanHint": "支持doc/docx/pdf文件",
    "video": "视频",
    "videoHint": "支持mp4文件",
    "audio": "音频",
    "audioHint": "支持mp3文件",
    "addChapter": "添加章节",
    "removeChapter": "删除章节",
    "addClassifyHint": "请在右侧输入要新增的课程分类信息，然后点击保存",
    "deleteClassifyHint": "被删除的课程分类将不可恢复，确定吗",
    "deleteCourseHint": "课程 {0} 被删除后将不可恢复，确定吗",
    "primaryClassifiy": "一级分类",
    "secondaryClassifiy": "二级分类",
    "label": "标签",
    "labelHint": "请添加课程标签",
    "open": "展开",
    "close": "收起",
    "total": "共{0}节",
    "edit": "编辑",
    "delete": "删除",
    "batchDelete": "批量删除",
    "courseOrder": "租户购买记录",
    "payTime": "支付时间",
    "courseOrderList": '购买列表',
    "payType": '支付方式',
    "payConfirm": '收款确认',
    "courseNature": "课程性质",
    "orderNumber": "支付单号",
    "orderNumberHint": "请输入支付单号",
  },
};


// WEBPACK FOOTER //
// ./src/i18n/course/zh-CN.js